var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLockFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33317H13.3333C13.7015 5.33317 14 5.63165 14 5.99984V13.9998C14 14.368 13.7015 14.6665 13.3333 14.6665H2.66667C2.29848 14.6665 2 14.368 2 13.9998V5.99984C2 5.63165 2.29848 5.33317 2.66667 5.33317H4V4.6665C4 2.45736 5.79086 0.666504 8 0.666504C10.2091 0.666504 12 2.45736 12 4.6665V5.33317ZM7.33333 10.4881V11.9998H8.66667V10.4881C9.0652 10.2576 9.33333 9.8267 9.33333 9.33317C9.33333 8.59677 8.7364 7.99984 8 7.99984C7.2636 7.99984 6.66667 8.59677 6.66667 9.33317C6.66667 9.8267 6.9348 10.2576 7.33333 10.4881ZM10.6667 5.33317V4.6665C10.6667 3.19374 9.47273 1.99984 8 1.99984C6.52724 1.99984 5.33333 3.19374 5.33333 4.6665V5.33317H10.6667Z",
    fill: "#6F7A76"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock-fill.5bc27889.svg";
export { ForwardRef as ReactComponent };